import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcSettings = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	stroke: "currentColor",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#5e06b6__clip0_3420_4422)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M13.0099 21.0834H8.52842L7.9111 18.3048C7.17642 18.0176 6.48935 17.621 5.87314 17.1284L3.15737 17.9833L0.916626 14.1023L3.01396 12.1775C2.89658 11.3977 2.89658 10.6046 3.01396 9.82475L0.916626 7.89884L3.15737 4.01787L5.87314 4.87272C6.48963 4.37972 7.17708 3.98273 7.91222 3.69521L8.52842 0.916687H13.0099L13.6272 3.69521C14.3619 3.98249 15.049 4.37909 15.6652 4.87159L18.381 4.01675L20.6217 7.89771L18.5244 9.82251C18.6418 10.6024 18.6418 11.3954 18.5244 12.1753L20.6217 14.1001L18.381 17.981L15.6652 17.1262C15.0491 17.6195 14.3621 18.0169 13.6272 18.3048L13.0099 21.0834Z",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M10.7691 14.3612C12.6254 14.3612 14.1302 12.8564 14.1302 11.0001C14.1302 9.1438 12.6254 7.63898 10.7691 7.63898C8.91278 7.63898 7.40796 9.1438 7.40796 11.0001C7.40796 12.8564 8.91278 14.3612 10.7691 14.3612Z",
			strokeWidth: 2
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "5e06b6__clip0_3420_4422",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 22,
			height: 22
		})
	}) })]
});
export default SvgIcSettings;
